import React from 'react'

const SectionLayout = ({ content, background }) => {
  return (
    <div className={background}>
      <div className='layout-spacing'>
        <div className='layout-width space-y-8 py-16'>
          {content}
        </div>
      </div>
    </div>

  )
}

export default SectionLayout